import classnames from 'classnames';
import React, { useState } from 'react';

import { HUIImage, HUIModal, Title, Wrapper } from 'root/widgets/common-components';

import { HIVE_STATIC_VERSION } from 'root/widgets/constants';

import './rumah-sunset-modal.scss';

// DO NOT USE THIS WIDGET
// THIS IS TO CATER THE SUNSET OF RUMAH. AND WILL BE REMOVED SHORTLY.
const RumahSunsetModal: React.FC<any> = () => {
  const [shouldShow, setShow] = useState(true);
  const rumahLogo = `https://cdn.pgimgs.com/hive-ui/static/${HIVE_STATIC_VERSION}/logo/rumah-horizontal-by-pg.svg`;
  const handleClose = () => setShow(false);

  return (
    <HUIModal className={classnames('rumah-sunset-modal-root')} show={shouldShow} onHide={handleClose} centered>
      <HUIModal.Header closeButton>
        <HUIImage className="rumah-logo" src={rumahLogo} alt="Rumah Logo" />
      </HUIModal.Header>
      <HUIModal.Body>
        <Wrapper className="rumah-sunset-content">
          <Title headerTag="h1" className="title">
            Ucapan selamat tinggal dari Rumah.com
          </Title>
          <p className="description">
            Terimakasih telah menjadikan Rumah.com sebagai portal properti andalan selama lebih dari 10 tahun. Mulai
            tanggal 1 Desember 2023 kami akan berhenti beroperasi.
          </p>
          <p className="description">
            Untuk kebijakan terkait data pribadi pengguna, silakan kunjungi{' '}
            <a href="https://www.propertygurugroup.com/terms-and-conditions/">halaman berikut</a>.
          </p>
          <p className="description">
            Untuk informasi mengenai penutupan ini, silakan membaca{' '}
            <a href="https://www.propertygurugroup.com/newsroom/a-message-from-group-ceo-and-managing-director-hari-v-krishnan/">
              pesan berikut
            </a>{' '}
            dari CEO kami Hari V. Krishnan.
          </p>
          <p className="description">
            Info terkait permintaan pengembalian dana agen, silakan hubungi{' '}
            <a href="mailto:agent_enquiry@rumah.com">agent_enquiry@rumah.com</a>.
          </p>
          <p className="description">
            Perjalanan PropertyGuru di Indonesia akan dilanjutkan oleh Asia Property Awards, penghargaan untuk yang
            terbaik di real estate. Pelajari selengkapnya tentang Indonesia Property Awards{' '}
            <a href="https://www.asiapropertyawards.com/en/award/indonesia/">di sini</a>.
          </p>
        </Wrapper>
      </HUIModal.Body>
    </HUIModal>
  );
};

RumahSunsetModal.displayName = 'RumahSunsetModal';

export default RumahSunsetModal;
